module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_3009.c77cb8bd.png";